import React, { useState, useContext } from 'react';
import ClaimsPendingApproval from './ClaimsPendingApproval';
import { DashboardContext } from 'context/DashboardContext';
import { api_srv } from '../../services';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import Loader from 'components/widgets/loader';
import styled from 'styled-components';
import { Link } from 'react-router-dom';



	const Container = styled.div`
	padding: 24px;
	background: #f8fafc;
	min-height: 100vh;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	`;

	const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 28px;
	`;

	const Title = styled.h1`
	margin: 0;
	font-size: 1.8rem;
	font-weight: 600;
	color: #1e293b;
	`;

	const SearchInput = styled.input`
	padding: 10px 16px;
	width: 260px;
	border: 1px solid #cbd5e1;
	border-radius: 6px;
	font-size: 0.95rem;
	outline: none;

	&::placeholder {
		color: #94a3b8;
	}

	&:focus {
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
	}
	`;

	const TableContainer = styled.div`
	background: white;
	border-radius: 10px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
	overflow: hidden;
	border: 1px solid #e2e8f0;
	`;

	const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	`;

	const Thead = styled.thead`
	background: #f1f5f9;
	`;

	const Th = styled.th`
	text-align: left;
	padding: 14px 16px;
	font-weight: 600;
	color: #475569;
	font-size: 0.9rem;
	border-bottom: 1px solid #e2e8f0;

	&:first-child {
		padding-left: 24px;
	}

	&:last-child {
		text-align: center;
	}
	`;

	const Tbody = styled.tbody``;

	const Tr = styled.tr`
	&:hover {
		background: #f8fafc;
	}
	`;

	const Td = styled.td`
	padding: 16px 16px;
	color: #334155;
	font-size: 0.95rem;
	border-bottom: 1px solid #f1f5f9;

	&:first-child {
		padding-left: 24px;
		font-weight: 500;
	}

	&:last-child {
		text-align: center;
	}
	`;

	const ActionLink = styled(Link)`
	color: #2563eb;
	font-weight: 500;
	text-decoration: none;
	padding: 4px 8px;
	border-radius: 4px;
	transition: all 0.12s;

	&:hover {
		background: #eff6ff;
		color: #1d4ed8;
	}
	`;

	const EmptyState = styled.div`
	padding: 60px 20px;
	text-align: center;
	color: #64748b;
	font-size: 1.1rem;
	`;

	const Pagination = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	padding: 16px;
	border-top: 1px solid #e2e8f0;
	color: #64748b;
	font-size: 0.9rem;
	`;

const ClaimsContainer = () => {
	const [claims] = useState([
    {
      type: 'Report',
      submittedDate: '10/10/2025',
      category: 'Accident',
      underwriter: 'Sanlam',
      risk: 'KBB-5492T',
      id: 7,
    },
    // Add more mock rows if needed
  ]);

  const [searchTerm, setSearchTerm] = useState('');

  const filteredClaims = claims.filter(
    (claim) =>
      claim.risk.toLowerCase().includes(searchTerm.toLowerCase()) ||
      claim.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      claim.underwriter.toLowerCase().includes(searchTerm.toLowerCase())
  );


	return (
<Container>
      <Header>
        <Title>Pending Claims</Title>
        <SearchInput
          placeholder="Search by risk, category, underwriter..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Header>

      <TableContainer>
        <Table>
          <Thead>
            <tr>
              <Th>Type</Th>
              <Th>Submitted Date</Th>
              <Th>Category</Th>
              <Th>Underwriter</Th>
              <Th>Risk</Th>
              <Th>Action</Th>
            </tr>
          </Thead>
          <Tbody>
            {filteredClaims.length === 0 ? (
              <tr>
                <td colSpan={6}>
                  <EmptyState>No pending claims found</EmptyState>
                </td>
              </tr>
            ) : (
              filteredClaims.map((claim) => (
                <Tr key={claim.id}>
                  <Td>{claim.type}</Td>
                  <Td>{claim.submittedDate}</Td>
                  <Td>{claim.category}</Td>
                  <Td>{claim.underwriter}</Td>
                  <Td>{claim.risk}</Td>
                  <Td>
                    <ActionLink to={`/dashboard/claims/view/${claim.id}`}>View</ActionLink>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>

        {filteredClaims.length > 0 && (
          <Pagination>
            Showing 1 – {filteredClaims.length} of {filteredClaims.length}
          </Pagination>
        )}
      </TableContainer>
    </Container>
	);
};

export default ClaimsContainer;
